import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
import { site_url } from "../config.js";

export default function SupportForm() {
  const location = useLocation();

  useEffect(() => {
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  const goBack = () => {
    window.history.back();
  };

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    description: "",
  });

  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");

    try {
      const customerId = localStorage.getItem("customer_id") || null;
      const res = await axios.post(`${site_url}/support-ticket`, {
        ...formData,
        customer_id: customerId ? Number(customerId) : null,
      });

      const ticketNo = res.data?.ticket_no ? ` Ticket #${res.data.ticket_no}` : "";
      setMessage(`Thank you! Your support request was submitted.${ticketNo}`);
      setFormData({
        name: "",
        phone: "",
        email: "",
        subject: "",
        description: "",
      });
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.response?.data?.errors?.email?.[0] ||
        "Something went wrong. Please try again later.";
      setMessage(errMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-vh-100">
      <Navbar expand="lg" className="navbar px-3">
        <Navbar.Brand className="fw-bold text-white">
          <center>
            <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" />{" "}
            Support Form
          </center>
        </Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center"></Nav>
      </Navbar>
      <div className="container mt-5">
        <div className="card shadow p-4">
          <h3 className="mb-4">Support Form</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="tel"
                name="phone"
                className="form-control"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <textarea
                name="description"
                className="form-control"
                rows="4"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </form>
          {message && (
            <div
              className={`alert mt-3 text-center ${message.includes("Thank you") ? "alert-success" : "alert-danger"}`}
              role="alert"
            >
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
